import CustomNode from './CustomNode';

export const nodeTypes = {
    customNode: CustomNode
}